export default {"src":"/_next/static/media/quality-indicators.9c5c18e0.svg","height":15,"width":12,"blurWidth":0,"blurHeight":0};